// extracted by mini-css-extract-plugin
export default {"banner":"aZQ3gn5gFCe5Rqlq5TBT","warning":"nY9MNB_8_DKtDt9ahgj7"};